import actions from 'src/modules/event/unpublish/eventUnpublishActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.UNPUBLISH_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.UNPUBLISH_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNPUBLISH_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNPUBLISH_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.UNPUBLISH_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.UNPUBLISH_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};

